import { render } from "./Toaster.vue?vue&type=template&id=d0c96658&ts=true"
import script from "./Toaster.vue?vue&type=script&lang=ts"
export * from "./Toaster.vue?vue&type=script&lang=ts"

import "./Toaster.vue?vue&type=style&index=0&id=d0c96658&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__